import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function ItemCertificate(props) {
  const { t } = useTranslation();

  const daley = (3+props.index) * 0.6
  
  const [style, SetStyle]= useState({
    animation: `slide-in-blurred-bottom  0.3s ${daley}s cubic-bezier(0.230, 1.000, 0.320, 1.000) both`,
  });
  
  function CleanStyle() {
    SetStyle({})
  }
  return(
    
    <a onMouseEnter={CleanStyle} onMouseOver={CleanStyle} onMouseLeave={CleanStyle}
      href={props.pdf} 
      target="_blank" 
      className="ItemCertificate" 
      style={style}
    >
      <div className="CertificateImg" style={{backgroundImage: `url(${props.img})`}}>
        <span className="Message">
          {t('see-certificate')}
        </span>
      </div>
      <h1 className="Title">
        {props.title}
      </h1>
    </a>
  );
}
